import React, { useEffect, useRef, useState } from 'react';
import './Slide02About.css';

const PARAS = [
  'BNFT is a next-generation crypto ecosystem built to merge digital identity with intelligent passive income systems. We believe the future of wealth lies in ownership \u2014 ownership of assets, ownership of data, and ownership of your digital self.',
  'Our platform is designed to transform NFTs from simple collectibles into secure, income-generating digital assets. By combining advanced blockchain architecture with automated reward mechanisms, BNFT creates a powerful environment where innovation meets financial opportunity.',
  'Security, transparency, and scalability are at the core of everything we build. Our smart contract infrastructure ensures decentralized operations, while our ecosystem is structured to provide sustainable and automated income models for our community.',
  'At BNFT, we are not just creating a project \u2014 we are building a protected gateway to digital wealth, empowering individuals to participate confidently in the evolving Web3 economy.',
];
const WORDS = PARAS.map(function(p){ return p.split(' '); });
const HL = [
  { 'Mi':'cyan','ME':'cyan','NFT':'cyan','digital':'gold','identity':'gold','ownership':'purple' },
  { 'income-generating':'gold','digital':'gold','blockchain':'purple','architecture':'purple','financial':'cyan' },
  { 'Security,':'gold','transparency,':'gold','scalability':'gold','smart':'cyan','contract':'cyan' },
  { 'protected':'purple','gateway':'purple','Web3':'cyan' },
];
const QUOTE = 'The future is digital. The future is decentralized. The future is BNFT.';

export default function Slide02About({ slideNumber, totalSlides, pdfMode }) {
  const canvasRef = useRef(null);
  const [phase, setPhase] = useState(pdfMode?7:0);
  const [w0, setW0] = useState(pdfMode?WORDS[0].length:0);
  const [w1, setW1] = useState(pdfMode?WORDS[1].length:0);
  const [w2, setW2] = useState(pdfMode?WORDS[2].length:0);
  const [w3, setW3] = useState(pdfMode?WORDS[3].length:0);
  const wc = [w0, w1, w2, w3];
  const [typed, setTyped] = useState(pdfMode?QUOTE:'');

  // Canvas
  useEffect(function(){
    var canvas = canvasRef.current;
    if(!canvas) return;
    var ctx = canvas.getContext('2d');
    var W = canvas.width = window.innerWidth;
    var H = canvas.height = window.innerHeight;
    var running = true;
    function onR(){ W=canvas.width=window.innerWidth; H=canvas.height=window.innerHeight; }
    window.addEventListener('resize', onR);
    var lts = [];
    function spLt(){
      var sx=Math.random()*W, sy=Math.random()<0.5?0:H;
      var a=Math.atan2(H/2-sy+(Math.random()-0.5)*H*0.5, W/2-sx+(Math.random()-0.5)*W*0.5);
      var len=Math.min(W,H)*(0.15+Math.random()*0.2);
      var pts=[{x:sx,y:sy}]; var px=sx,py=sy;
      for(var i=0;i<8+Math.floor(Math.random()*7);i++){px+=Math.cos(a)*(len/10)+(Math.random()-0.5)*30;py+=Math.sin(a)*(len/10)+(Math.random()-0.5)*30;pts.push({x:px,y:py});}
      if(Math.random()>0.45&&pts.length>4){var bi=2+Math.floor(Math.random()*(pts.length-4)),ba=a+(Math.random()-0.5)*1.4;var bp=[{x:pts[bi].x,y:pts[bi].y}];var bx=pts[bi].x,by=pts[bi].y;for(var j=0;j<3+Math.floor(Math.random()*3);j++){bx+=Math.cos(ba)*(len/14)+(Math.random()-0.5)*16;by+=Math.sin(ba)*(len/14)+(Math.random()-0.5)*16;bp.push({x:bx,y:by});}lts.push({pts:bp,life:0,mx:8+Math.random()*5,c:'0,200,255',w:0.5});}
      lts.push({pts:pts,life:0,mx:12+Math.random()*10,c:Math.random()>0.35?'165,42,58':Math.random()>0.5?'251,191,36':'122,21,48',w:0.8+Math.random()*1.2});
    }
    var streams=[];for(var i=0;i<25;i++){var ch=[];for(var j=0;j<8+Math.floor(Math.random()*12);j++)ch.push(String.fromCharCode(0x30A0+Math.floor(Math.random()*96)));streams.push({x:Math.random()*W,y:Math.random()*H,speed:0.3+Math.random()*0.6,chars:ch,alpha:Math.random()*0.03+0.006,size:Math.random()*4+8});}
    var parts=[];for(var i=0;i<45;i++)parts.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.2,vy:-0.06-Math.random()*0.2,sz:Math.random()*1.6+0.3,al:Math.random()*0.15+0.04,hue:[195,45,270,195,210][Math.floor(Math.random()*5)]});
    var T=0;
    function draw(){
      if(!running)return;T++;ctx.clearRect(0,0,W,H);
      ctx.strokeStyle='rgba(165,42,58,0.01)';ctx.lineWidth=0.4;
      for(var x=0;x<W;x+=80){ctx.beginPath();ctx.moveTo(x+Math.sin(T*0.001+x*0.008)*2,0);ctx.lineTo(x,H);ctx.stroke();}
      for(var y=0;y<H;y+=80){ctx.beginPath();ctx.moveTo(0,y+Math.cos(T*0.001+y*0.008)*2);ctx.lineTo(W,y);ctx.stroke();}
      var hts=[H*0.2,H*0.45,H*0.68,H*0.9];
      for(var i=0;i<hts.length;i++){var o=(T*(0.6+i*0.2))%(W+300)-150;var g=ctx.createLinearGradient(o-180,0,o,0);g.addColorStop(0,'transparent');g.addColorStop(0.5,i%2===0?'rgba(165,42,58,0.04)':'rgba(251,191,36,0.03)');g.addColorStop(1,'transparent');ctx.strokeStyle=g;ctx.lineWidth=0.8;ctx.beginPath();ctx.moveTo(o-180,hts[i]);ctx.lineTo(o,hts[i]);ctx.stroke();ctx.beginPath();ctx.arc(o,hts[i],1.5,0,6.28);ctx.fillStyle=i%2===0?'rgba(165,42,58,0.1)':'rgba(251,191,36,0.07)';ctx.fill();}
      ctx.font='10px monospace';
      for(var i=0;i<streams.length;i++){var s=streams[i];s.y+=s.speed;if(s.y>H+200){s.y=-200;s.x=Math.random()*W;}for(var ci=0;ci<s.chars.length;ci++){var cy2=s.y-ci*s.size;if(cy2<-20||cy2>H+20)continue;var fd=ci===0?s.alpha*2.5:s.alpha*(1-ci/s.chars.length);ctx.fillStyle='rgba(165,42,58,'+(ci===0?fd:fd*0.4)+')';ctx.fillText(s.chars[ci],s.x,cy2);}}
      for(var i=0;i<parts.length;i++){var p=parts[i];p.x+=p.vx;p.y+=p.vy;if(p.y<-20){p.y=H+20;p.x=Math.random()*W;}if(p.x<-20)p.x=W+20;if(p.x>W+20)p.x=-20;var fl=p.al+Math.sin(T*0.01+p.x)*0.04;ctx.beginPath();ctx.arc(p.x,p.y,p.sz,0,6.28);ctx.fillStyle='hsla('+p.hue+',80%,70%,'+Math.max(0,fl)+')';ctx.fill();}
      if(T%40<2)spLt();if(T%75<2&&Math.random()>0.3)spLt();
      for(var i=lts.length-1;i>=0;i--){var l=lts[i];l.life++;if(l.life>l.mx){lts.splice(i,1);continue;}var al=1-l.life/l.mx;ctx.beginPath();ctx.moveTo(l.pts[0].x,l.pts[0].y);for(var j=1;j<l.pts.length;j++)ctx.lineTo(l.pts[j].x+(Math.random()-0.5)*4,l.pts[j].y+(Math.random()-0.5)*4);ctx.strokeStyle='rgba('+l.c+','+(al*0.08)+')';ctx.lineWidth=(l.w||1)+3;ctx.stroke();ctx.beginPath();ctx.moveTo(l.pts[0].x,l.pts[0].y);for(var j=1;j<l.pts.length;j++)ctx.lineTo(l.pts[j].x+(Math.random()-0.5)*1.5,l.pts[j].y+(Math.random()-0.5)*1.5);ctx.strokeStyle='rgba('+l.c+','+(al*0.2)+')';ctx.lineWidth=l.w||1;ctx.stroke();ctx.beginPath();ctx.moveTo(l.pts[0].x,l.pts[0].y);for(var j=1;j<l.pts.length;j++)ctx.lineTo(l.pts[j].x+(Math.random()-0.5)*0.5,l.pts[j].y+(Math.random()-0.5)*0.5);ctx.strokeStyle='rgba(255,255,255,'+(al*0.05)+')';ctx.lineWidth=0.3;ctx.stroke();}
      requestAnimationFrame(draw);
    }
    draw();
    return function(){ running=false; window.removeEventListener('resize',onR); };
  }, []);

  // Phases
  useEffect(function(){
    var t=[setTimeout(function(){setPhase(1);},200),setTimeout(function(){setPhase(2);},500),setTimeout(function(){setPhase(3);},900),setTimeout(function(){setPhase(4);},1400),setTimeout(function(){setPhase(5);},1800),setTimeout(function(){setPhase(6);},6500),setTimeout(function(){setPhase(7);},8000)];
    return function(){ t.forEach(clearTimeout); };
  },[]);

  // Word counters - paragraph 0
  useEffect(function(){
    if(phase!==5&&!(pdfMode&&phase>=5))return;
    var c=0,total=WORDS[0].length,cancelled=false;
    var iv=setInterval(function(){if(cancelled)return;c++;setW0(c);if(c>=total)clearInterval(iv);},45);
    return function(){cancelled=true;clearInterval(iv);};
  },[phase]);
  // Paragraph 1
  useEffect(function(){
    if(phase!==5&&!(pdfMode&&phase>=5))return;var c=0,total=WORDS[1].length,cancelled=false,iv;
    var tm=setTimeout(function(){if(cancelled)return;iv=setInterval(function(){if(cancelled)return;c++;setW1(c);if(c>=total)clearInterval(iv);},45);},900);
    return function(){cancelled=true;clearTimeout(tm);if(iv)clearInterval(iv);};
  },[phase]);
  // Paragraph 2
  useEffect(function(){
    if(phase!==5&&!(pdfMode&&phase>=5))return;var c=0,total=WORDS[2].length,cancelled=false,iv;
    var tm=setTimeout(function(){if(cancelled)return;iv=setInterval(function(){if(cancelled)return;c++;setW2(c);if(c>=total)clearInterval(iv);},45);},1800);
    return function(){cancelled=true;clearTimeout(tm);if(iv)clearInterval(iv);};
  },[phase]);
  // Paragraph 3
  useEffect(function(){
    if(phase!==5&&!(pdfMode&&phase>=5))return;var c=0,total=WORDS[3].length,cancelled=false,iv;
    var tm=setTimeout(function(){if(cancelled)return;iv=setInterval(function(){if(cancelled)return;c++;setW3(c);if(c>=total)clearInterval(iv);},45);},2700);
    return function(){cancelled=true;clearTimeout(tm);if(iv)clearInterval(iv);};
  },[phase]);

  // Typing quote
  useEffect(function(){
    if(phase!==6&&!(pdfMode&&phase>=6))return;var i=0;
    var iv=setInterval(function(){i++;setTyped(QUOTE.slice(0,i));if(i>=QUOTE.length)clearInterval(iv);},30);
    return function(){clearInterval(iv);};
  },[phase]);

  // Pulses
  useEffect(function(){
    if(phase<3)return;var prc=document.getElementById('abt-pulses');if(!prc)return;
    function pulse(c,w,d){var el=document.createElement('div');el.className='about__pulse';prc.appendChild(el);var sz=Math.max(window.innerWidth,window.innerHeight)*2.2;el.animate([{width:'0px',height:'0px',opacity:0.2,borderWidth:w+'px',borderStyle:'solid',borderColor:c},{width:sz+'px',height:sz+'px',opacity:0,borderWidth:'1px',borderStyle:'solid',borderColor:'transparent'}],{duration:d,easing:'cubic-bezier(0.22,1,0.36,1)'}).onfinish=function(){el.remove();};}
    pulse('rgba(165,42,58,0.12)',2,2500);
    var i1=setInterval(function(){pulse('rgba(165,42,58,0.06)',1.5,3000);},7000);
    var i2=setInterval(function(){pulse('rgba(251,191,36,0.04)',1,3500);},9000);
    return function(){clearInterval(i1);clearInterval(i2);};
  },[phase]);

  function rp(idx) {
    var words = WORDS[idx];
    var shown = wc[idx];
    var hm = HL[idx];
    var result = [];
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      var vis = i < shown;
      var hlc = hm[w] || hm[w.replace(/[.,\u2014;:!?]/g, '')] || null;
      var cls = 'abt-w notranslate' + (vis ? ' abt-w--vis' : '') + (hlc ? ' abt-hl abt-hl--' + hlc : '');
      result.push(React.createElement('span', { key: i, className: cls }, w + ' '));
    }
    return result;
  }

  return React.createElement('div', { className: 'about' },
    React.createElement('canvas', { ref: canvasRef, className: 'about__canvas' }),
    React.createElement('div', { className: 'about__pulses', id: 'abt-pulses' }),
    React.createElement('div', { className: 'about__flash' + (phase >= 1 ? ' fire' : '') }),
    React.createElement('svg', { className: 'about__circuits' + (phase >= 6 ? ' show' : ''), viewBox: '0 0 1920 1080', preserveAspectRatio: 'none' },
      React.createElement('line', { x1: '0', y1: '350', x2: '1920', y2: '350', className: 'about__cir-h' }),
      React.createElement('line', { x1: '0', y1: '730', x2: '1920', y2: '730', className: 'about__cir-h about__cir-h2' }),
      React.createElement('line', { x1: '300', y1: '0', x2: '300', y2: '1080', className: 'about__cir-v' }),
      React.createElement('line', { x1: '1620', y1: '0', x2: '1620', y2: '1080', className: 'about__cir-v' }),
      React.createElement('path', { d: 'M0 200 L400 400 L600 300 L1920 500', className: 'about__cir-d' }),
      React.createElement('path', { d: 'M1920 800 L1400 600 L1000 750 L0 550', className: 'about__cir-d about__cir-d2' })
    ),
    React.createElement('div', { className: 'about__nodes' + (phase >= 6 ? ' show' : '') },
      [{l:'BEP-20',x:'4%',y:'10%',s:48,d:'0s',du:'18s'},{l:'USDT',x:'90%',y:'8%',s:52,d:'-6s',du:'20s'},{l:'DeFi',x:'2%',y:'80%',s:40,d:'-10s',du:'22s'},{l:'Web3',x:'92%',y:'75%',s:44,d:'-3s',du:'16s'}].map(function(n,i){
        return React.createElement('div', { key: i, className: 'about__hex', style: {left:n.x,top:n.y,animationDelay:n.d,animationDuration:n.du} },
          React.createElement('svg', { width: n.s, height: n.s*0.87, viewBox: '0 0 60 52' },
            React.createElement('path', { d: 'M30 1L56 14V38L30 51 4 38V14Z', fill: 'none', stroke: 'rgba(165,42,58,0.05)', strokeWidth: '0.6' }),
            n.l ? React.createElement('text', { x: '30', y: '29', textAnchor: 'middle', fill: 'rgba(165,42,58,0.07)', fontSize: '5', fontFamily: 'Orbitron', fontWeight: '700' }, n.l) : null
          )
        );
      })
    ),
    ['tl','tr','bl','br'].map(function(pos){
      return React.createElement('div', { key: pos, className: 'about__corner about__corner--'+pos+(phase>=6?' show':'') },
        React.createElement('svg', { viewBox: '0 0 100 100', fill: 'none' },
          React.createElement('path', { d: 'M0 45V2H2V0H45', stroke: pos.includes('b')?'rgba(251,191,36,0.5)':'rgba(165,42,58,0.5)', strokeWidth: '1' }),
          React.createElement('circle', { cx: '2', cy: '2', r: '2.5', fill: pos.includes('b')?'rgba(251,191,36,0.4)':'rgba(165,42,58,0.4)' },
            React.createElement('animate', { attributeName: 'r', values: '2;3.5;2', dur: '3s', repeatCount: 'indefinite' })
          )
        )
      );
    }),
    React.createElement('div', { className: 'about__content' },
      React.createElement('div', { className: 'about__label'+(phase>=2?' show':'') }, String(slideNumber).padStart(2,'0')+' / '+String(totalSlides).padStart(2,'0')+' \u2014 ABOUT'),
      React.createElement('h1', { className: 'about__title notranslate'+(phase>=3?' show':'') }, 'ABOUT ', React.createElement('span', { className: 'about__title-cyan' }, 'BNFT')),
      React.createElement('div', { className: 'about__sub'+(phase>=3?' show':'') }, 'WHO WE ARE'),
      React.createElement('div', { className: 'about__dv'+(phase>=4?' show':'') }),
      React.createElement('div', { className: 'about__card'+(phase>=5?' show':'') },
        React.createElement('div', { className: 'about__card-glow' }),
        React.createElement('div', { className: 'about__card-scan' }),
        React.createElement('div', { className: 'about__card-top' }),
        React.createElement('div', { className: 'about__card-body' },
          React.createElement('p', { className: 'about__para' }, rp(0), React.createElement('span', {className:'para-full'}, PARAS[0])),
          React.createElement('p', { className: 'about__para' }, rp(1), React.createElement('span', {className:'para-full'}, PARAS[1])),
          React.createElement('p', { className: 'about__para' }, rp(2), React.createElement('span', {className:'para-full'}, PARAS[2])),
          React.createElement('p', { className: 'about__para' }, rp(3), React.createElement('span', {className:'para-full'}, PARAS[3]))
        )
      ),
      React.createElement('div', { className: 'about__quote'+(phase>=6?' show':'') },
        React.createElement('span', { className: 'about__qt' }, typed),
        React.createElement('span', { className: 'about__cur' })
      )
    ),
    React.createElement('div', { className: 'about__bot'+(phase>=7?' show':'') },
      React.createElement('span', null, 'bnft.live')
    )
  );
}
